const data = {
	error: {
		fld: ['Ошибка в данных.', 'Проверте значения полей.'],
	},
}

export default data
